const locale = {
  'commodityList.message.enterOE': '请输入OE号',
  'commodityList.message.addSuccess': '添加到购物车成功，可去购物车查看',
  'commodityList.message.fetchProductsSuccess': '批量查询成功',
  'commodityList.message.placeholderOENumber': `一次最多查询1000个OE编号；按行分隔多个条目，例如：
000001
000002
000003`,
  'commodityList.text.AllTotal': '已为您找到 {total} 个结果',
  'commodityList.text.groupTotal': '找到 {total} 个结果',
  'commodityList.button.search': '搜索',
  'commodityList.button.reset': '重置',
  'commodityList.title.accessoriesDetails': '配件详情',
  'commodityList.title.replacementNumber': '替换号',
  'commodityList.title.storeName': '店铺',
  'commodityList.title.availabilityAndLeadTime': '库存 & 交货时间',
  'commodityList.title.price': '价格',
  'commodityList.title.operation': '操作',
  'commodityList.message.selectProduct': '请选择要添加的商品',
  'commodityList.text.selectedProducts': '已选择{count}个商品（共{quantity}件），',
  'commodityList.text.total': '合计：',
  'commodityList.button.batchAddToCart': '加入购物车',
  'commodityList.message.maxDataLimit': '超过2000条数据，只会搜索前2000条',
  'commodityList.message.noImportData': '没有导入数据',
  'commodityList.message.batchQueryLoading': '批量查询中...',
  'commodityList.message.noProductData': '没有商品数据',
  'commodityList.message.settleSuccess': '结算单保存成功',
  'commodityList.message.orderFailed': '下单失败，请稍后重试',
  'commodityList.button.orderNow': '立即下单',
  'commodityList.import.oeNumber': '零件号',
  'commodityList.import.brand': '配件品牌',
  'commodityList.import.quantity': '数量',
  'commodityList.import.rule1': '1.仅支持导入 .xlsx 文件。',
  'commodityList.import.rule2':
    '2.上传后可批量新增或更新列表。下方表格展示可导入字段，标有 * 为必填项。',
  'commodityList.button.batchImport': '批量导入',
  'commodityList.text.supportBatchQuery': '支持批量查询 OE 号并自动填充数量',

  'commodityList.import.downloadTemplateUrl':
    'https://fe-static.cassmall.com/assets/applications/20250715163725/导入模板.xlsx',

  'commodityList.message.invalidData': '有商品数量不符合要求符合要求，请检查',

  'commodity.multiple-sale.error.minSaleCount': '购买数量不能小于最小销售数量',
  'commodity.multiple-sale.error.multipleSaleCount': '购买数量需要为倍数销售数量的倍数',
  total_match_found: '{total} 个结果匹配',
  total_Item_selected: '{total} 个商品已选择',
  Total_colon_total: '总计: {total}',
  Request_a_quote: '请求报价',
  Coming_soon: '即将推出',
  Place_order: '立即下单',
  Specifications: '规格',
  Pack_Size: '包装尺寸',
  total_pcs_case: '{total} pcs/case',
  MOQ: 'MOQ',
  total_pcs: '{total} pcs',
  In_stock: '有库存',
  Backorder: '缺货',
  Immediate: '立即发货',
  total_Found: '{total} 已找到',
  total_Unfound: '{total} 未找到',
  Availability_and_Lead_Time_Tip: '交货时间是从下单到商品准备发货的时间。',
  Supported_Manufacturers: '支持的制造商',
};

export default locale;
